import { Component, Input } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";

@Component({
    selector: "edp-modal-confirm-changes",
    templateUrl: "./edp-modal-confirm-changes.component.html",
    styleUrls: ["./edp-modal-confirm-changes.component.scss"],
})
export class EdpModalConfirmChangesComponent {
    @Input() public data: IModalData;

    constructor(private readonly edpModalService: EdpModalService) {}

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }
}
